<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}BOM查询
        </div>
        <div class="fr" v-if="justShow"></div>
        <div class="fr" v-else>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="(repleacePartsEdit && formData.id != null) || (repleacePartsAdd && formData.id == null)"
                     @click="saveData">保存
          </el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  配件编码
                </th>
                <!-- <td v-if="justShow">{{formData.partsCode}}</td>
                <td v-else>
                  <el-input type="text" autocomplete="off" :maxlength="20" v-model="formData.partsCode"
                            @blur="inspection" clearable/>
                </td> -->
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.partsCode" :readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog = true"></i>
                  </el-input>
                </td>

                <th>
                  <em class="f-red">*</em>
                  配件名称
                </th>
                <td v-if="justShow">{{formData.partsName}}</td>
                <td v-else>
                  <el-input type="text" autocomplete="off" :maxlength="40" v-model="formData.partsName" :disabled="true"/>
                </td>

                <th>
                  配件简称
                </th>
                <td v-if="justShow">{{formData.partsShortName}}</td>
                <td v-else>
                  <el-input type="text" autocomplete="off" :maxlength="40" v-model="formData.partsShortName" :disabled="true"/>
                </td>

                <th>
                  配件型号
                </th>
                <td v-if="justShow">{{formData.partsSpec}}</td>
                <td v-else>
                  <el-input type="text" autocomplete="off" :maxlength="40" v-model="formData.partsSpec" :disabled="true"/>
                </td>

              </tr>
              <tr>
                <th>
                  适用产品型号
                </th>
                <td v-if="justShow">{{formData.partsSuit}}</td>
                <td v-else>
                  <el-input type="text" autocomplete="off" :maxlength="300" v-model="formData.partsSuit" :disabled="true"/>
                </td>

                <th>
                  配件类型
                </th>
                <td>
                  <el-form-item>
                    <el-select :disabled='true'
                               v-model="formData.bigPartsCategoryId"
                               placeholder="大类"
                               @change='fittingsSelectOne' clearable
                               style="width: 49%!important;">
                      <el-option v-for="item in productOptions2" :key="item.value" :label="item.label"
                                 :value="item.value" :disabled="true">
                      </el-option>
                    </el-select>
                    <el-select :disabled='true'
                               v-model="formData.smallPartsCategoryId" placeholder="小类" clearable
                               style="width: 49%!important;margin-left:2%;">
                      <el-option v-for="item in productOptions3" :key="item.value" :label="item.label"
                                 :value="item.value" :disabled="true">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <th>
                  <em class="f-red">*</em>
                  产品类型
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select :disabled='true'
                               v-model="formData.bigCategoryId" placeholder="大类" @change='productSelectOne'

                               style="width: 49%!important;">
                      <el-option v-for="item in productOptions0" :key="item.value" :label="item.label"
                                 :value="item.value" :disabled="true">
                      </el-option>
                    </el-select>
                    <el-select :disabled='true'
                               v-model="formData.smallCategoryId" placeholder="小类" clearable
                               style="width: 49%!important;margin-left:2%;">
                      <el-option v-for="item in productOptions1" :key="item.value" :label="item.label"
                                 :value="item.value" :disabled="true">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <th>
                  品牌
                </th>
                <td>
                  <el-form-item>
                    <el-select :disabled='true'
                               v-model="formData.brandId" placeholder="请选择品牌"
                               clearable>
                      <el-option v-for="item in brandOptions" :key="item.value" :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <!-- <tr>
                <th>注意事项</th>
                <td colspan="3">
                  <el-input v-model="formData.disableReason"/>
                </td>
              </tr> -->
              <tr>
                <th>配件图片</th>
                <td >
                  <div>
                    <div>
                      <photo-show :photo-url="formData.partsPic" v-if="justShow"/>
                      <photoUpload :photo-url.sync="formData.partsPic" v-else/>
                    </div>
                  </div>
                </td>
                <th>配件图片1</th>
                <td>
                  <div>
                    <div>
                      <photo-show :photo-url="formData.partsPic1" v-if="justShow"/>
                      <photoUpload :photo-url.sync="formData.partsPic1" v-else/>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item">
            <div class="title first">
              <b>替换配件</b>
              <el-button type="primary" class="button-sty btn_zdy2" v-if="repleacePartsEdit" @click="showPartsPpo=true">
                <i class="el-icon-document-add"></i>
                添加替代配件
              </el-button>
              <el-button type="danger" class="button-sty btn_zdy2" v-if="repleacePartsEdit" @click="bulkDeletion">
                <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                批量删除
              </el-button>
            </div>
            <!-- style="margin: 12px 0 0 50px;width: 1135px;" -->
            <el-table ref="replacePartsTable" border height="300"
                      :data="formData.basPartsReplaceDTOList" class="table_item pic_item"
                      :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"
                      :header-row-style="{height:'36px'}"
                      :row-style="{height:'30px',fontSize:'12px', background: '#fff'}"
            >
              <el-table-column :show-overflow-tooltip='true' type="selection" width="55"/>
              <el-table-column :show-overflow-tooltip='true' prop="partsName" label="配件名称" width="100"/>
              <el-table-column :show-overflow-tooltip='true' prop="partsCode" label="配件编码" width="100"/>
              <el-table-column :show-overflow-tooltip='true' prop="partsSpec" label="配件型号" width="100"/>
              <el-table-column :show-overflow-tooltip='true' prop="priority" label="优先级" width="80">
                <template slot-scope="scope">
                  <vxe-input v-model="scope.row.priority" :min="1" :max="99" type="number" style="width: 50px"/>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip='true' prop="partsSuit" label="适用产品型号" width="100"/>
              <el-table-column :show-overflow-tooltip='true' prop="brandName" label="品牌" width="70"/>
              <el-table-column :show-overflow-tooltip='true' prop="costPrice" label="采购价" width="70">
                <template slot-scope="scope">
                  <span v-if="!currentIsSite">{{scope.row.sitePrice}}</span>
                  <span v-else>*</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip='true' prop="sitePrice" label="出厂价" width="70">
                <template slot-scope="scope">
                  <span v-if="currentSiteLevel != 2">{{scope.row.sitePrice}}</span>
                  <span v-else>*</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip='true' prop="level1SitePrice" label="一级价" width="70">
                <template slot-scope="scope">
                  <span v-if="currentSiteLevel != 2">{{scope.row.level1SitePrice}}</span>
                  <span v-else>*</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip='true' prop="level2SitePrice" label="二级价" width="70">
                <template slot-scope="scope">
                  <span v-if="currentSiteLevel != 2">{{scope.row.level2SitePrice}}</span>
                  <span v-else>*</span>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip='true' prop="userPrice" label="零售价" width="70"/>
              <el-table-column :show-overflow-tooltip='true' prop="bigCategoryName" label="产品大类" width="100"/>
              <!-- <el-table-column :show-overflow-tooltip='true' prop="smallCategoryName" label="产品小类" width="100"/>
              <el-table-column :show-overflow-tooltip='true' prop="bigPartsCategoryName" label="配件大类" width="100"/>
              <el-table-column :show-overflow-tooltip='true' prop="smallPartsCategoryName" label="配件小类" width="100"/> -->
              <!-- <el-table-column :show-overflow-tooltip='true' prop="precautions" label="注意事项" width="189"/> -->
              <el-table-column :show-overflow-tooltip='true' prop="precautions" label="注意事项" width="189">
                <template slot-scope="scope">
                  <vxe-input v-model="scope.row.precautions" type="text" style="width: 175px"/>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip='true' label="操作">
                <template slot-scope="scope">
                  <div @click="handleDelete(scope)">
                    <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- <div class="d-item" v-if="!justShow">
            <div class="title first">
              <b>修改记录</b>
            </div>
            <el-table ref="filterTable" border height="130" :data="formData.historyData" class="table_item pic_item"
                      style="margin: 12px 0 0 50px;width: 1135px;"
                      :header-cell-style="{ background: '#F6FAFF',padding: '0',borderTop: '1px solid #eaeaea',fontSize:'12px',color:'#808080'}"
                      :header-row-style="{height:'36px'}"
                      :row-style="{height:'30px',fontSize:'12px', background: '#fff'}">

              <el-table-column :show-overflow-tooltip='true' prop="createBy" label="创建人" width=""/>
              <el-table-column :show-overflow-tooltip='true' prop="createTime" label="创建时间" width=""/>
              <el-table-column prop="bcostPrice" label="修改前采购价" width=""/>
              <el-table-column prop="acostPrice" label="修改后采购价" width=""/>
              <el-table-column prop="bsitePrice" label="修改前出厂价" width=""/>
              <el-table-column prop="asitePrice" label="修改后出厂价" width=""/>
              <el-table-column prop="blevel1SitePrice" label="修改前一级价" width=""/>
              <el-table-column prop="alevel1SitePrice" label="修改后一级价" width=""/>
              <el-table-column prop="blevel2SitePrice" label="修改前二级价" width=""/>
              <el-table-column prop="alevel2SitePrice" label="修改后二级价" width=""/>
              <el-table-column prop="buserPrice" label="修改前零售价" width=""/>
              <el-table-column prop="auserPrice" label="修改后零售价" width=""/>

            </el-table>
          </div> -->
        </div>
      </div>
    </el-form>

    <warehouse
      v-if="showWarehouse"
      @commit="commit"
      :visiable.sync="showWarehouse"
      :param="{excludeWarehouseType: [3]}"
      multi="true"/>

    <warehouseLocation
      v-if="showWarehouseLocation"
      @commit="commit1"
      :visiable.sync="showWarehouseLocation"
      multi="true"
      :warehouseId="formData.warehouseId"
    />

    <replacePartsPop
      v-if="showPartsPpo"
      @confirm="confirm"
      :visiable.sync="showPartsPpo"
      :replacePartsObj="getReplacePartsObj"
      multi="true"
    />

    <!-- 配件资料 -->
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitPartsRow"
      :visiable.sync="showPreconditionDialog" multi="true" />

  </div>
</template>
<script>
import photoUpload from "@/components/formItem/photoUpload.vue";
import {fetchTree} from "@/api/admin/type_tree";
import store from "@/store";
import replacePartsPop from '@/views/dialogCommon/peiJianDialog.vue';
import warehouse from '@/views/dialogCommon/radioWarehouseDialog.vue';
import warehouseLocation from '@/views/dialogCommon/radioWarehouseLocationDialog.vue';
import api from "@/api/projectApi";
import {mapGetters} from "vuex";
import {editPageMixins, siteMixins} from "@/mixins/tabChang";
import DictSelect from "@/components/formItem/dictSelect.vue";
import MultiplePhotoShow from "@/components/formItem/multiplePhotoShow.vue";
import PhotoShow from "@/components/formItem/photoShow.vue";
import preconditionDialog from '@/views/dialogCommon/radioPartsDialog.vue';

export default {
  mixins: [editPageMixins, siteMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {PhotoShow, MultiplePhotoShow, DictSelect, replacePartsPop, warehouse, warehouseLocation, photoUpload,preconditionDialog,},
  data() {
    return {
      justShow: false,
      repleacePartsEdit: false,
      repleacePartsAdd: false,
      showPreconditionDialog:false,
      dataId: '',
      getDataUrl: '/basic/basParts/getById',
      addDataUrl: '/basic/basParts/add',
      updateDataUrl: '/basic/basParts/update',
      getBrandListUrl: '/basic/snCompanyBrand/getBrandList',
      getHistoryUrl: '/basic/basPartsHistory/getListPage',
      getReplacementAccessoriesUrl: '/basic/basParts/getReplacePartsListPage',
      getNotReplacementAccessoriesUrl: '/basic/basParts/getNotReplacePartsListPage',
      deleteReplacePartsUrl: '/basic/basPartsReplace/delete',
      addReplacePartsUrl: '/basic/basPartsReplace/add',
      productOptions0: [],
      productOptions1: [],
      productOptions2: [],
      productOptions3: [],
      brandOptions: [],
      formData: {
        partsId:null,
        // id: null,  // 主键id,自动新增
        // createBy: '',  // 创建人
        // createTime: '',  // 创建时间
        // partsCode: '',  // 编码,同厂商下惟一
        // partsName: '',  // 名称
        // partsSpec: '',  // 型号
        // partsSuit: '',  // 适用产品型号
        // brandId: '',  // 品牌ID,关联sn_company_brand.id
        // costPrice: 0,  // 采购价
        // sitePrice: 0,  // 出厂价
        // level1SitePrice: 0,  // 一级价
        // level2SitePrice: 0,  // 二级价
        // userPrice: 0,  // 零售价
        // bigCategoryId: '',  // 产品大类ID,关联bas_item_category.id
        // smallCategoryId: '',  // 产品小类ID,关联bas_item_category.id
        // bigPartsCategoryId: '',  // 配件大类ID,关联bas_item_category.id
        // smallPartsCategoryId: '',  // 配件小类ID,关联bas_item_category.id
        // saleStat: 1,  // 可售状态：0否1是
        // usable: 1,  // 启用:0禁用；1启用
        // isNeedReturn: 1,  // 是否需要返厂：0否1是
        // usePeriod: '',  // 生效日期(yyyy-mm-dd格式）
        // lostUsePeriod: '',  // 失效日期(yyyy-mm-dd格式）
        // costMaterial: 0,  // 耗材物资：0否1是
        // costFix: 1,  // 维修物资：0否1是
        // guaranteePeriodMonthes: 0,  // 保修期(按月)
        // costPerDate: 0,
        // qrCodeFlag: 0,  // 一物一码物料：0否1是
        // applyMethod: 0,  // 申购方式：0不限；1现金购买；2配件额度
        // warehouseId: null,  // 默认仓库：关联bas_warehouse.id字段.
        // locationId: null,  // 默位库位: 关联bas_warehouse_location.id
        // warehouseName: null,
        // locationName: null,
        // safeInv: 0,  // 安全库存
        // erpPartsCode: '',  // ERP编码：用于对接
        // supplier: '',  // 供应商名称
        // autoCheck: 0,
        // maxApplyQty: 0,
        // siteMaxQty: 0,
        // siteShareQty:0,
        // minPackageQty:0,
        // minApplyQty:0,
        // partsPic: '',  // 图片
        // basPartsReplaceIdList: [],
        // historyData: [],
        // supplyStat: 1,
        // isSbItem: 1,
        // checkPeriodDates: 0,
        // pricePeriodDates: 0,
        // orderPeriodDates: 0,
        // buyPeriodDates: 0,
        // purchasePeriodDates: 0,
        // isSinglePackage: 0,
        // abcType: null,
        // disableReason: null,
        basPartsReplaceDTOList: []
      },
      showPartsPpo: false,
      showWarehouse: false,
      showWarehouseLocation: false,


      // 以上大小ID  类型信息
      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,

      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',

      showProductCategoryDialog: false,

      replacementAccessoriesData: [],
    };
  },
  watch: {
    "formData.basPartsReplaceIdList": {
      handler(newVal, oldVal) {
        console.log('绑定id变化', newVal, oldVal)
        this.loadReplacementAccessories()
      },
      deep: true
    }
  },
  computed: {
    getReplacePartsObj() {
      let temp = []
      if (this.formData.basPartsReplaceDTOList) {
        temp = this.formData.basPartsReplaceDTOList.map(item => item.id)
      }
      return {
        basPartsReplaceIdList: temp,
        dataId: this.formData.partsId
      }
    },

    ...mapGetters(["permissions"])
  },
  created() {
    this.repleacePartsEdit = this.permissions['repleacePartsEdit']
    this.repleacePartsAdd = this.permissions['repleacePartsAdd']
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.getData()
    this.loadProductOption0()
    this.loadProductOption2()
    this.loadBrandOption()
    this.loadReplacementAccessories()
  },
  methods: {
    setSiteData() {
      this.justShow = this.currentIsSite
    },

    commitPartsRow(data) {
      console.log(data,"选择的值");
      // this.formData = data;
      this.formData.partsId= data.id
      this.formData.partsCode= data.partsCode
      this.formData.partsName = data.partsName
    },

    showWarehouseLocationFunc() {
      if (this.formData.warehouseId) {
        this.showWarehouseLocation = true
      } else {
        this.$message.warning('请先选中仓库')
      }
    },

    inspection() {
      if (this.formData.partsCode) {
        this.$http({
          url: api.basParts.inspectionUrl,
          method: 'post',
          data: {
            value: this.formData.partsCode,
            id: this.formData.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("配件编码已存在，请重新输入")
            this.formData.partsCode = null
          }
        })
      }
    },

    // 仓库库位
    commit1(data) {
      console.log('选中仓库库位', data)
      // this.formData.warehouseId = data.warehouseId
      this.formData.locationId = data.id
      // this.formData.warehouseName = data.warehouseName
      this.formData.locationName = data.locationName
      console.log(this.formData)
    },

    // 仓库
    commit(data) {
      console.log('选中仓库', data)
      this.formData.warehouseId = data.warehouseId
      // this.formData.locationId = data.locationId
      this.formData.warehouseName = data.warehouseName
      // this.formData.locationName = data.locationName
    },

    // 配件弹框选中
    confirm(data) {
      console.log('选中配件', data)
      data.forEach(item => {
        item.priority = 1
        this.formData.basPartsReplaceDTOList.push(item)
      })

      // data.forEach(item => {
      //   this.formData.basPartsReplaceIdList.push(item.id)
      // })
      // this.loadReplacementAccessories()
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: this.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // 加载产品大类
    loadProductOption0() {
      fetchTree({
        categoryType: 1,  // 产品
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions0 = []
        response.data.data.forEach(item => {
          this.productOptions0.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 加载产品小类
    loadProductOption1() {
      if (this.formData.bigCategoryId === ''
        || this.formData.bigCategoryId === null
        || this.formData.bigCategoryId === undefined) {
        this.productOptions1 = []
      } else {
        fetchTree({
          categoryType: 1,  // 产品
          // usable: 1,  // 加载启用的
          parentId: this.formData.bigCategoryId
        }).then(response => {
          this.productOptions1 = []
          response.data.data.forEach(item => {
            this.productOptions1.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },

    // 加载配件大类
    loadProductOption2() {
      fetchTree({
        categoryType: 2,  // 配件
        // usable: 1  // 加载启用的
      }).then(response => {
        this.productOptions2 = []
        response.data.data.forEach(item => {
          this.productOptions2.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },

    // 加载配件小类
    loadProductOption3() {
      if (this.formData.bigPartsCategoryId === ''
        || this.formData.bigPartsCategoryId === null
        || this.formData.bigPartsCategoryId === undefined) {
        this.productOptions3 = []
        this.formData.smallPartsCategoryId = ''
      } else {
        fetchTree({
          categoryType: 2,  // 配件
          // usable: 1,  // 加载启用的
          parentId: this.formData.bigPartsCategoryId
        }).then(response => {
          this.productOptions3 = []
          response.data.data.forEach(item => {
            this.productOptions3.push({
              label: item.categoryName,
              value: item.id
            })
          })
        })
      }
    },

    // 产品大类选中加载小类
    productSelectOne() {
      this.productOptions1 = []
      this.formData.smallCategoryId = null
      this.loadProductOption1()
    },

    // 配件大类选中加载小类
    fittingsSelectOne() {
      this.formData.smallPartsCategoryId = null
      this.productOptions3 = []
      this.loadProductOption3()
    },


    // // 上传成功
    // handleSuccess(response, file,) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn = true;
    //   console.log(response, "上传成功后response")
    //   console.log(file, "上传成功后file")

    //   console.log(response.data.url, "url")
    //   this.formData.partsPicList = [
    //     {url: response.data.url}
    //   ]
    // },

    // handleRemove(response, file, fileList) {
    //   // 删除成功后，显示上传按钮
    //   this.upload_btn = false;
    //   this.formData.partsPicList = null
    // },


    // 加载替换配件
    loadReplacementAccessories() {
      if (this.formData.basPartsReplaceIdList == null || this.formData.basPartsReplaceIdList.length === 0) {
        this.replacementAccessoriesData = []
      } else {
        this.$http({
          url: api.basParts.getPartsListByIds,
          method: 'post',
          data: {
            partsIds: this.formData.basPartsReplaceIdList,
          }
        }).then(res => {
          this.replacementAccessoriesData = res.data.data
        })
      }
    },

    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.basPartsReplace.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data || {};
          console.log(this.formData.partsPic,'this.formData.partsPic');
          if (this.formData.basPartsReplaceIdList == null) {
            this.formData.basPartsReplaceIdList = []
          }
          this.loadProductOption1()
          this.loadProductOption3()
        })
      }
    },

    // 保存数据
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          // console.log(this.formData.partsPic,'this.formData.partsPic');
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            this.$http({
              url: api.basPartsReplace.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.goBackIndex()
              this.$mask.close()
              // this.$emit('editViewDataUpdate')
              // this.$baseReload()
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      });
    },

    // 单条删除
    handleDelete({row}) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.formData.basPartsReplaceIdList = this.formData.basPartsReplaceIdList.filter(item => item !== row.id)
        console.log(this.formData.basPartsReplaceIdList, '删除后')
      })
    },

    // 批量删除
    bulkDeletion() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let selected = this.$refs.replacePartsTable.selection
        console.log('sdf', selected)
        let list = this.formData.basPartsReplaceDTOList;
        selected.forEach(item => {
          list = list.filter(item1 => item1.id != item.id)
        })
        this.formData.basPartsReplaceDTOList = list
      })
    },

    // 删除数据请求
    deleteData(deleteList) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$http({
          url: this.deleteReplacePartsUrl,
          method: "post",
          data: {
            deleteIdList: deleteList
          }
        }).then(res => {
          this.$message.success("删除成功！")
          this.$baseReload()
        }).catch(e => {
          console.error(e)
          this.$message.error("删除失败！")
        })
      })
    }
  },
};

</script>
<style lang="scss" scoped>
.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;

}

</style>
